<template>
  <Modal :open="open" @close="close">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full text-button-font-primary bg-primary">
      <DocumentReportIcon class="h-6 w-6 text-green-600" aria-hidden="true" />
    </div>
    <VariantContractList :variant="this.variant" />
    <div class="text-center mt-5">
      <GenericButton @click="close">{{ $t("Back") }}</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { DocumentReportIcon } from "@heroicons/vue/outline";
import { GenericButton, Modal } from "@estaly/ui";
import VariantContractList from "@/views/store/products/details/variant/details/contracts/VariantContractList.vue";
export default {
  components: {
    Modal,
    DocumentReportIcon,
    GenericButton,
    VariantContractList,
  },
  props: {
    variant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    open: function () {
      return this.variant !== null;
    },
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
  },
};
</script>
